import * as React from 'react';
import { Card, Row, Col } from 'antd';

import { AddUserTaskView } from 'src/app/general/user-tasks/parts/add-user-tasks.view';
import { ZuluIcon } from 'src/app/shared/icon';

export const HomeView: React.SFC<{ userId: number }> = (props: { userId: number }): JSX.Element => (
	<div className="window window-normal">
		<div></div>
		<Card
			title="Welcome"
			extra={<ZuluIcon type="inbox" />}
			style={{ width: '100%' }}
		>
			<p>WELCOME TO BOOKEM ZULU!</p>
			<p>Using Ant Design <a href="http://ant.design/"> Site</a></p>

			<Row gutter={16}>
				<Col xs={24} lg={12}>
					<AddUserTaskView
						kanban
						useLoginFilter={true}
						extraFilter={ds => {
							//ds.addFilter('assignedToId', 'eq', props.userId);
						}}
						setBusy={e => { }}
					/>
				</Col>
			</Row>
		</Card>
	</div>
);



// WEBPACK FOOTER //
// ./src/app/home/home.view.tsx